module.exports = __webpack_public_path__ + "img/bg-green-5.a80ec718.png";